import { render, staticRenderFns } from "./editApprove.vue?vue&type=template&id=05cb4b93&scoped=true"
import script from "./editApprove.vue?vue&type=script&lang=js"
export * from "./editApprove.vue?vue&type=script&lang=js"
import style0 from "./editApprove.vue?vue&type=style&index=0&id=05cb4b93&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cb4b93",
  null
  
)

export default component.exports